export function slugify(str: string) {
  return str
    .toLowerCase() // Convert to lowercase
    .replace(/[^a-z0-9\s-]/g, "") // Remove all non-alphanumeric characters except spaces and hyphens
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-") // Ensure no two hyphens are back to back
    .replace(/^-+|-+$/g, ""); // Remove leading and trailing hyphens
}
